import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import CarCardButtonTooltip from "./CarCardButtonTooltip.js";
import CarCardImage from "./CarCardImage.js";
import CarCardImageSkeleton from "./CarCardImageSkeleton.js";
import CarCardLocation from "./CarCardLocation.js";
import CarCardLocationSkeleton from "./CarCardLocationSkeleton.js";
import CarCardMarkers from "./CarCardMarkers.js";
import CarCardMarkersSkeleton from "./CarCardMarkersSkeleton.js";
import CarCardPayment from "./CarCardPayment.js";
import CarCardPaymentSkeleton from "./CarCardPaymentSkeleton.js";
import CarCardPrice from "./CarCardPrice.js";
import CarCardPriceSkeleton from "./CarCardPriceSkeleton.js";
import CarCardTable from "./CarCardTable.js";
import CarCardTableSkeleton from "./CarCardTableSkeleton.js";
import CarCardTitle from "./CarCardTitle.js";
import CarCardTitleSkeleton from "./CarCardTitleSkeleton.js";
import './CarCard.css';/* empty css             */
const CarCard = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-car-card", className), ...props, children });
};
CarCard.Image = CarCardImage;
CarCard.ImageSkeleton = CarCardImageSkeleton;
CarCard.Location = CarCardLocation;
CarCard.LocationSkeleton = CarCardLocationSkeleton;
CarCard.Table = CarCardTable;
CarCard.TableSkeleton = CarCardTableSkeleton;
CarCard.Price = CarCardPrice;
CarCard.PriceSkeleton = CarCardPriceSkeleton;
CarCard.Payment = CarCardPayment;
CarCard.PaymentSkeleton = CarCardPaymentSkeleton;
CarCard.Markers = CarCardMarkers;
CarCard.MarkersSkeleton = CarCardMarkersSkeleton;
CarCard.Title = CarCardTitle;
CarCard.TitleSkeleton = CarCardTitleSkeleton;
CarCard.ButtonTooltip = CarCardButtonTooltip;
export {
  CarCard as default
};
//# sourceMappingURL=CarCard.js.map
